import type { SubmitOverlay } from '../../core/types';

const OVERLAY_KEYS: (keyof SubmitOverlay)[] = ['name', 'alias', 'aliase', 'description', 'workspace', 'creator', 'datacenter'];

/** overlay 合并入口；仅 Pipeline Kernel 调用 */
export function mergeOverlay<TPayload extends Record<string, unknown>>(payload: TPayload, overlay?: SubmitOverlay): TPayload {
  if (!overlay) {
    return payload;
  }

  const merged: Record<string, unknown> = { ...payload };

  for (const key of OVERLAY_KEYS) {
    const value = overlay[key];
    if (value === undefined || value === '') {
      continue;
    }
    if (key === 'aliase' && overlay.alias != null && overlay.alias !== '') {
      continue;
    }
    if (key === 'aliase') {
      merged.alias = value;
      continue;
    }
    if (key === 'workspace' && Array.isArray(merged.workspace) && typeof value === 'string') {
      merged.workspace = [value];
      continue;
    }
    merged[key] = value;
  }

  return merged as TPayload;
}
